export default __webpack_public_path__ + "static/media/RunHorseLight_3_2.b457a912.jpg";